export const ARIA_AGENTS = ['ARIA_EUR', 'ARIA_GBP'];
